/* src/app/shared/components/footer/footer.component.scss */
.footer-container {
  background-color: #0E3E32;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #D8D8D8;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 1000;
}
/*# sourceMappingURL=footer.component.css.map */
